import { gql } from "@apollo/client";

export const insertMachineCenterCorporateBO = gql`
    mutation insertMachineCenter($machineCenter: machine_center_insert_input!) {
        insert_machine_center_one(object: $machineCenter) {
            machine_center_id
        }
    }
`;

export const getBottleneckMachineCenter = gql`
    query getBottleneckMachineCenter($productionLineId: Int!) {
        machine_center(where: { production_line_id: { _eq: $productionLineId }, is_bottleneck: { _eq: true } }) {
            machine_center_id
        }
    }
`;

export const getMachineCenterPlcAddress = gql`
    query getMachineCenterPlcAddress($where: machine_center_bool_exp) {
        machine_center(where: $where) {
            machine_center_id
            name
        }
    }
`;

export const updateMachineCenter = gql`
    mutation updateMachineCenter($machineCenterId: Int!, $changes: machine_center_set_input!) {
        update_machine_center(where: { machine_center_id: { _eq: $machineCenterId } }, _set: $changes) {
            affected_rows
            returning {
                machine_center_id
                is_bottleneck
            }
        }
    }
`;

export const getMachineCenterDetailsBO = gql`
    query getMachineCenter($machine_center_id: Int!) {
        machine_center(where: { machine_center_id: { _eq: $machine_center_id }, disabled_at: { _is_null: true } }) {
            created_at
            updated_at
            name
            short_name
            manufacturer
            model_number
            is_bottleneck
            is_enabled
            hmi_code
            minimum_downtime
            downtime_trigger_threshold
            downtime_method_capture {
                downtime_method_capture_id
                name
            }
            plc_address
            production_line {
                production_line_id
                mill {
                    mill_id
                    division_id
                    corporate_id
                    mill_modules(where: { module_type_id: { _eq: 3 } }) {
                        is_enabled
                    }
                }
            }
            machine_center_modules(where: { module_type_id: { _eq: 3 } }) {
                is_enabled
            }
            machine_center_oee_config {
                input_method_id
            }
            email_notification_machine_center_settings(where: { notification_type_id: { _eq: 6 } }) {
                id
                trigger_time
                is_enabled
            }
        }
    }
`;

export const GetMachineCenterFailureDetailsInfoBO = gql`
    query GetMachineCenterFailureDetailsInfoBO($machine_center_id: Int!) {
        machine_center(where: { machine_center_id: { _eq: $machine_center_id }, disabled_at: { _is_null: true } }) {
            machine_center_id
            name
            areas(where: { disabled_at: { _is_null: true } }) {
                area_id
                name_translation_id
                functional_locations(
                    where: { subordinate_to_id: { _is_null: true }, disabled_at: { _is_null: true } }
                ) {
                    functional_location_id
                    name_translation_id
                    location_specific_functional_location_failure_codes {
                        failure_code_id
                    }
                }
            }
            non_location_specific_machine_center_failure_codes {
                failure_code_id
            }
        }
    }
`;

export const subscribeMachineCenterDetailsHMICodeBO = gql`
    subscription getMachineCenter($machine_center_id: Int!) {
        machine_center(where: { machine_center_id: { _eq: $machine_center_id } }) {
            hmi_code
        }
    }
`;

export const getMachineCenterCurrentStatus = gql`
    query ($machine_center_ids: [Int!], $limit: Int!) {
        event_report(
            where: { machine_center_id: { _in: $machine_center_ids }, end_date: { _is_null: true } }
            order_by: { start_date: desc }
            limit: $limit
        ) {
            event_report_id
            measure_metric_id
            machine_center_id
            start_date
            end_date
            failure_type {
                code
                failure_type_id
                name
                color_code
                is_location_specific
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
            failure_code {
                failure_code_id
                name
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
            functional_location {
                functional_location_id
                translation {
                    id
                    translation_names {
                        name
                        language_id
                    }
                }
            }
            area {
                area_id
                translation {
                    id
                    translation_names {
                        name
                        language_id
                    }
                }
            }
        }
    }
`;

export const insertMachineCenterLog = gql`
    mutation insertMachineCenterLog($machineCenterLog: machine_center_logs_insert_input!) {
        insert_machine_center_logs_one(object: $machineCenterLog) {
            machine_center_id
            local_timestamp
            local_timezone
            utc_timestamp
            downtime_method_capture_id
            machine_status
            current_failure_details_step
            last_app_update_date
            last_data_update_date
            last_internet_connection_recovery_date
            message
            trigger
            app_release_version
            operator_id
            operative_system
            operative_system_version
            device_type
            device_model
        }
    }
`;

export const getAllMachineCenters = gql`
    query getMachineCenters {
        machine_center {
            machine_center_id
            name
            production_line_id
            production_line {
                name
                mill {
                    mill_id
                }
            }
        }
    }
`;

export const getAllFunctionalLocations = gql`
    query getFunctionalLocations {
        functional_location {
            functional_location_id
            translation {
                id
                translation_names {
                    name
                    language_id
                }
            }
            area {
                machine_center {
                    name
                    machine_center_id
                    production_line_id
                }
            }
        }
    }
`;

export const setMachineCentersClusterId = gql`
    mutation setMachineCentersCluster($machineCenterIds: [Int!], $changes: machine_center_set_input!) {
        update_machine_center(where: { machine_center_id: { _in: $machineCenterIds } }, _set: $changes) {
            affected_rows
            returning {
                machine_center_id
                cluster_id
            }
        }
    }
`;

export const setMachineCentersOrderByProductionLine = gql`
    mutation setMachineCentersOrderByProductionLine($machineCenters: [machine_center_insert_input!]!) {
        insert_machine_center(
            objects: $machineCenters
            on_conflict: { constraint: machine_center_pkey, update_columns: [order] }
        ) {
            affected_rows
            returning {
                machine_center_id
            }
        }
    }
`;

export const upsertMachineCenterModuleAspenPlus = gql`
    mutation upsertMachineCenterModuleAspenPlus(
        $machine_center_id: Int!
        $module_type_id: Int!
        $is_enabled: Boolean!
    ) {
        insert_machine_center_modules_one(
            object: { machine_center_id: $machine_center_id, module_type_id: $module_type_id, is_enabled: $is_enabled }
            on_conflict: {
                constraint: machine_center_modules_machine_center_id_module_type_id_key
                update_columns: [is_enabled]
            }
        ) {
            id
            machine_center_id
            module_type_id
            is_enabled
        }
    }
`;

export const upsertMachineCenterOeeConfig = gql`
    mutation upsertMachineCenterOeeConfig($machine_center_id: Int!, $input_method_id: Int!) {
        insert_machine_center_oee_config_one(
            object: { machine_center_id: $machine_center_id, input_method_id: $input_method_id }
            on_conflict: {
                constraint: machine_center_oee_config_machine_center_id_key
                update_columns: [input_method_id]
            }
        ) {
            id
            machine_center_id
            input_method_id
        }
    }
`;

export const getOeeInputMethods = gql`
    query getOeeInputMethods {
        oee_input_method(order_by: { id: asc }) {
            id
            default_translation {
                default_meeting_translation_names {
                    language_id
                    name
                }
            }
        }
    }
`;

export const upsertMachineCenterEmailNotificationSetting = gql`
    mutation upsertMachineCenterEmailNotificationSetting(
        $notificationSetting: [email_notification_machine_center_settings_insert_input!]!
    ) {
        insert_email_notification_machine_center_settings(
            objects: $notificationSetting
            on_conflict: {
                constraint: email_notification_machine_center_settings_pkey
                update_columns: [is_enabled, trigger_time]
            }
        ) {
            affected_rows
            returning {
                id
            }
        }
    }
`;
